// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, Typography } from '@mui/material';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                mt: 'auto',
                pt: 3
            }}
        >
            <Divider sx={{ borderColor: theme.palette.divider }} />
            <Box
                sx={{
                    py: 2,
                    px: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 0.4,
                    background:
                        theme.palette.mode === 'dark'
                            ? theme.palette.dark.main
                            : 'linear-gradient(135deg, rgba(94,53,177,0.04) 0%, rgba(57,73,171,0.04) 100%)',
                    borderRadius: '0 0 8px 8px'
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        letterSpacing: '0.02em',
                        textAlign: 'center',
                        fontSize: { xs: '0.72rem', sm: '0.875rem' },
                        lineHeight: 1.5
                    }}
                >
                    2026 Copyright &ndash; Continuum AI Global Private Limited
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: theme.palette.text.disabled,
                        letterSpacing: '0.03em',
                        fontSize: { xs: '0.65rem', sm: '0.7rem' },
                        textAlign: 'center'
                    }}
                >
                    Version:&nbsp;1.0&nbsp;&nbsp;&nbsp;Built:&nbsp;20260424&nbsp;0500
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
